import {SxProps} from "@mui/material"

const colors = ["#EA746D", "#226CA6", "#008475", "#5199C2", "#7C4F92"]
export function stringToAvatar(name: string, sx?: SxProps) {
  let initials = ""
  let background = ""

  if (name !== undefined) {
    const parts = name.split(" ")
    initials =
      parts.length > 1
        ? `${parts[0].substring(0, 1)}${parts[1].substring(0, 1)}`
        : `${parts[0].substring(0, 1)}`
  }

  const colorIndex = name.length % colors.length
  background = colors[colorIndex] || colors[0]
  return {
    sx: {
      bgcolor: background,
      width: "2.3rem",
      height: "2.3rem",
      fontSize: "0.875rem",
      letterSpacing: "-0.015em",
      fontWeight: "600",
      ...sx,
    },
    children: initials.toUpperCase(),
  }
}
